// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "timeInRoute-7jttr";
export { _1 as "__esModule", _2 as "timeInRoute" }
export default { "__esModule": _1, "timeInRoute": _2 }
